import useNetworkStatus from "../../../hooks/useNetworkStatus";
import NoInternetPage from "../NoInternetPage";

const CheckConnection = ({ children }) => {
  const { isOnline } = useNetworkStatus();

  return isOnline ? children : <NoInternetPage />;
};

export default CheckConnection;
